import { render, staticRenderFns } from "./CheckboxPicker.vue?vue&type=template&id=47c3d056&"
import script from "./CheckboxPicker.vue?vue&type=script&lang=js&"
export * from "./CheckboxPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports